import { defineMessages } from 'react-intl';

const messages = defineMessages({
  login: {
    id: 'menu.login',
    defaultMessage: 'Login',
  },
  logoutInfo: {
    id: 'menu.logoutInfo',
    defaultMessage: 'Not {name}?',
  },
  logout: {
    id: 'menu.logoutLink',
    defaultMessage: 'Logout',
  },
  signUp: {
    id: 'menu.createLink',
    defaultMessage: 'Register now',
  },
  signUpInfo: {
    id: 'menu.createInfo',
    defaultMessage: 'New here?',
  },
});

export default messages;
